var _path, _g, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitkaMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.89655C24.5 7.29943 24.384 7.92275 24.1476 8.7416C23.9142 9.54971 23.5746 10.512 23.1523 11.5776C22.3081 13.7082 21.1435 16.2276 19.8678 18.7106C18.592 21.1936 17.2097 23.631 15.9322 25.5988C15.2933 26.5829 14.6842 27.444 14.1308 28.1325C13.7057 28.6614 13.3254 29.0733 13 29.3599C12.6746 29.0733 12.2943 28.6614 11.8692 28.1325C11.3158 27.444 10.7067 26.5829 10.0678 25.5988C8.79029 23.631 7.40804 21.1936 6.13223 18.7106C4.85647 16.2276 3.69186 13.7082 2.84765 11.5776C2.42542 10.512 2.08578 9.54971 1.85245 8.7416C1.61601 7.92275 1.5 7.29943 1.5 6.89655C1.5 5.24754 2.66729 3.65838 4.76386 2.45346C6.84682 1.25636 9.75766 0.5 13 0.5C16.2423 0.5 19.1532 1.25636 21.2361 2.45346C23.3327 3.65838 24.5 5.24754 24.5 6.89655Z",
    fill: "#C4C4C4",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10C21 14.4183 17.4183 18 13 18C8.58172 18 5 14.4183 5 10C5 5.58172 8.58172 2 13 2C17.4183 2 21 5.58172 21 10Z",
    fill: "#F8F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10C21 14.4183 17.4183 18 13 18C8.58172 18 5 14.4183 5 10C5 5.58172 8.58172 2 13 2C17.4183 2 21 5.58172 21 10Z",
    stroke: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84848 11.9593C8.84848 11.6824 9.07295 11.4579 9.34986 11.4579V11.4579C9.62676 11.4579 9.85124 11.6824 9.85124 11.9593V13.4986C9.85124 13.7755 9.62676 14 9.34986 14V14C9.07295 14 8.84848 13.7755 8.84848 13.4986V11.9593Z",
    fill: "#FF7878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2369 11.6075C10.2369 11.5249 10.306 11.4579 10.3912 11.4579H11.0854C11.1706 11.4579 11.2397 11.5249 11.2397 11.6075V13.8505C11.2397 13.9331 11.1706 14 11.0854 14H10.3912C10.306 14 10.2369 13.9331 10.2369 13.8505V11.6075Z",
    fill: "#FF7878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84848 7.86916H11.2397V11.6075H8.84848V7.86916Z",
    fill: "#FF7878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34986 7.86916V8.50467V8.50467C9.00906 8.50467 8.73278 8.78095 8.73278 9.12175V11.5701H8V9.47663V9.21902C8 8.47351 8.60435 7.86916 9.34986 7.86916V7.86916Z",
    fill: "#FF7878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6997 7.86916V8.50467V8.50467C11.0405 8.50467 11.3168 8.78095 11.3168 9.12175V11.5701H12.0496V9.47663V9.21902C12.0496 8.47351 11.4452 7.86916 10.6997 7.86916V7.86916Z",
    fill: "#FF7878"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0441,
    cy: 6.85981,
    rx: 0.887052,
    ry: 0.859813,
    fill: "#FF7878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7989 11.9593C14.7989 11.6824 15.0234 11.4579 15.3003 11.4579V11.4579C15.5772 11.4579 15.8016 11.6824 15.8016 11.9593V13.4986C15.8016 13.7755 15.5772 14 15.3003 14V14C15.0234 14 14.7989 13.7755 14.7989 13.4986V11.9593Z",
    fill: "#FF7878"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1873 11.6075C16.1873 11.5249 16.2564 11.4579 16.3416 11.4579H17.0358C17.121 11.4579 17.1901 11.5249 17.1901 11.6075V13.8505C17.1901 13.9331 17.121 14 17.0358 14H16.3416C16.2564 14 16.1873 13.9331 16.1873 13.8505V11.6075Z",
    fill: "#FF7878"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7989 7.86916H17.1901V11.6075H14.7989V7.86916Z",
    fill: "#FF7878"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3003 7.86916V8.50467V8.50467C14.9595 8.50467 14.6832 8.78095 14.6832 9.12175V11.5701H13.9504V9.47663V9.21902C13.9504 8.47351 14.5548 7.86916 15.3003 7.86916V7.86916Z",
    fill: "#FF7878"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6501 7.86916V8.50467V8.50467C16.9909 8.50467 17.2672 8.78095 17.2672 9.12175V11.5701H18V9.47663V9.21902C18 8.47351 17.3956 7.86916 16.6501 7.86916V7.86916Z",
    fill: "#FF7878"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9945,
    cy: 6.85981,
    rx: 0.887052,
    ry: 0.859813,
    fill: "#FF7878"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4215,
    cy: 10.6602,
    rx: 0.206612,
    ry: 0.23301,
    fill: "#FF7878"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 10.6602,
    rx: 0.206612,
    ry: 0.23301,
    fill: "#FF7878"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5785,
    cy: 10.6602,
    rx: 0.206612,
    ry: 0.23301,
    fill: "#FF7878"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_220",
    x: 0.5,
    y: 1.5,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_220",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitkaMarker);
export default __webpack_public_path__ + "static/media/Bitka-marker.f7362105ca4c1c997347fd893bc00ad6.svg";
export { ForwardRef as ReactComponent };